import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaldoService {
  private socket: Socket;
  private newRechargeSubject = new Subject<any>();

  private saldoSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public saldo$: Observable<number> = this.saldoSubject.asObservable();

  constructor(private http: HttpClient) {
    this.socket = io(environment.API_SECURITY); // Cambia la URL según sea necesario
    this.socket.on('newRecharge', (data) => {
      // this.newRechargeSubject.next(data);
       this.newRechargeSubject.next(data)
     });
     this.socket.on('asignarSaldo', (data) => {
      // this.newRechargeSubject.next(data);
       this.newRechargeSubject.next(data)
     });
  }

  getNewRecharges() {
    return this.newRechargeSubject.asObservable();
  }

  // actualizarSaldo(): void {
  //   this.http.get<any>(`${environment.API_SECURITY}/saldos`).subscribe(response => {
  //     const nuevoSaldo = response.monto || 0;
  //     this.saldoSubject.next(nuevoSaldo);
  //   });
  // }

  obtenerSaldoActual(): number {
    return this.saldoSubject.getValue();
  }

  totalizadorSaldos(): Observable<any> {
		return this.http.get<any>(environment.API_SECURITY + '/saldos/saldoAsignado');
	}

  ultimoSaldo(): Observable<any> {
		return this.http.get<any>(environment.API_SECURITY + '/saldos/ultimoSaldo');
	}

  // asignarSaldo(): Observable<any> {
	// 	return this.http.get<any>(environment.API_SECURITY + '/asignarSaldo');
	// }

  
}